import React, { Component } from 'react';
import Config from './Config';
import List from './List';
import { Scrollbars } from 'react-custom-scrollbars';
import './css/Customer.css';
import Modal from './Modal';
import FX from './functions/functions';
import SearchBox from './SearchBox';
import OrderEdge from './OrderEdge';
import AddressEditor from './AddressEditor';
import AddressViewer from './AddressViewer';
import ContextMenu from './ContextMenu';

class Customer extends Component {
  constructor(props) {
    super(props);
    this.state = { context: {show:false}, checked: [] };
    this.props.root.autoKey = (e) => {
      if(e.target.tagName === 'BODY' && !this.props.root.state.detail){
          document.getElementById('item_search').value = '';
          document.getElementById('item_search').focus();
      }
      if(e.key === 'Enter'){
          console.log(e.target.id.split("_")[0]);
          console.log(this.enterAction);
          if(typeof this.enterAction[e.target.id.split("_")[0]] === 'function'){
             this.enterAction[e.target.id.split("_")[0]](e);
          }
      }
      if(e.key === 'Escape'){
            e.target.blur();
            e.target.value = '';
            this.state = {filter:'', activeProduct: null, context: {show:false}, checked: [] };
            this.setState(this.state);
            console.log('xxasasx');
      }
    console.log(e);
    }
  }
  componentDidMount(){
    console.log('oooo');
    this.retrieveData(30);
  }
  componentWillUnmount(){
    this.props.root.autoKey = undefined;
  }
  enterAction = {
    'recBox': (e)=> {
      console.log(e.key);
      e.target.blur();
      this.closeProductModal();
    },
    'activeProductQty' : (e) => {
      console.log(e.key);
      e.target.blur();
      this.addActiveItem();
    }
  }
  componentDidUpdate(prevprops, prevstate){
    FX.doFocus(this);
    console.log(prevstate);
    console.log(prevprops);
    console.log(this.props.root.state.detail);
    console.log(prevprops.root.state.detail);
    console.log(this.loading);
    var k = parseInt( this.props.root.state.detail , 10 );
    if( !this.loading && typeof this.props.root.state.detail === 'number'  ){
       this.loading = true;
       console.log(this.props.root.state.detail);
       this.retrieveDetail(this.props.root.state.detail);
    }
  }
  handleClick = (tgt, e) => {
      var detail = this.props.root.state.detail;
      detail[tgt] = 1 * e.target.checked;
      this.props.root.setState({detail:detail});
  }
  componentWillMount(){
     FX.urlRetrieve.bind(this)(this.props.root.state);
  }
  
  addCustomer = () => {
    var detail = this.props.root.setState({detail:{
        active_tariff_id: null,
        archive_customer_access_id: null,
        archive_customer_id: null,
        archive_default_psid: null,
        auto_email_template_id: 0,
        autohold: 0,
        company_number: null,
        cut_off: "21:59:59",
        default_shipping: 1,
        delay_lead_time: 0,
        dhl_account: null,
        dim_names: ["Height","Width","Depth"],
        dispatch_note_note: null,
        dispatch_reference_format: null,
        email: null,
        enable_batch_numbers: 1,
        enable_composites: 0,
        enable_expiries: 1,
        eori: null,
        fullname: null,
        id: -1,
        invoice_attach: null,
        invoice_due: 0,
        invoice_fuel: 2,
        invoice_name: null,
        invoiceable: 0,
        line_1: null,
        manage_inventory: 0,
        name: "",
        phone: null,
        reorderMail: 1,
        show_dispatch_id: 0,
        status: 0,
        stopped: null,
        url: "",
        vat_number: null,
        warehouse_site: 0
      }});
  }
  retrieveData = (limit) => {
    if(isNaN(limit)){
      limit = 30;
    }
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    FX.load(this.props.root,'customer?limit=500&sort=name' , (res, i) => {
      var customers = this.props.root.state.customers;
      customers = res.customers;
      this.props.root.setState({ customers : customers  });
      this.props.root.loadNextPage =  this.retrieveData;
    });
  }
  retrieveDetail = (id) => {
    console.log('pop');
    var sort_str = this.props.root.sort_str ? this.props.root.sort_str : '';
    FX.load(this.props.root,'customer/' + id , (res, i) => {
      console.log(res.order);
      console.log('xxxxp');
      if(res.order && res.order.id){
        this.props.root.setState({ detail : res.order  });
      }
      else {
        FX.navigate.bind(this.props.root, this.props.root.state.panel, undefined ,'/clients')();
      }
      this.loading = false;
    });
  }
  save = () => {
    console.log(this.props.root.state.detail);
    var detail = this.props.root.state.detail;
    if(detail.id < 0){
        FX.load(this.props.root,'customer/create' , (res, i) => {
              console.log(res);
              console.log(res.success);
              if(res.success){
                 console.log(res);
              }
              this.props.root.setState({detail : res.customer});
        }, {method:'POST',data:{detail : detail}});
    }
    else {
        FX.load(this.props.root,'customer/save' , (res, i) => {
              console.log(res);
              console.log(res.success);
              if(res.success){
                 console.log(res);
              }
              this.props.root.setState({detail : res.customer});
        }, {method:'POST',data:{detail : detail}});
    }
  }
  deleteDispatch = ( disp ) => {
    console.log(disp);
    FX.load(this.props.root,'dispatch/delete' , (res, i) => {
          console.log(res);
          console.log(res.success);
          if(res.success){
             console.log(res);
          }
          //this.props.root.setState({detail : res.order});
    }, {method:'POST',data:{dispatch : disp}});
    this.retrieveDetail(this.props.root.state.detail.id);
  }
  showList = () => {
    //this.props.root.setState({detail:undefined});
    FX.navigate.bind(this.props.root, this.props.root.state.panel, undefined ,'/clients')();
  }
  selectProduct = (prod) => {
    console.log(prod);
    console.log(this.props.root.state.detail.order_items);
    this.setState({activeProduct : prod});
    this.focusTgt = 'activeProductQty';
    console.log('xxxx');
  }
  addActiveItem = () => {
    var found = false;
    var detail = this.props.root.state.detail
    var order_items = detail.order_items;
    var activeProduct = this.state.activeProduct;
    order_items.some( (oi, i) => {
        console.log(this.state.activeProduct.id);
        console.log(oi);
        if(this.state.activeProduct.id == oi.product.id){
          oi.quantity += parseInt(document.getElementById('activeProductQty').value, 10);
          found = true;
        }
        return found;
    });
    if (!found) {
      console.log(this.state.activeProduct.name);
      order_items.push({
        id:-1,
        product: activeProduct,
        product_id: activeProduct.id,
        quantity: parseInt(document.getElementById('activeProductQty').value, 10)
      });
    }
    detail.order_items = order_items;
    this.setState({activeProduct: null});
    this.props.root.setState({order_items : order_items});
    this.focusTgt = 'prod_search';
  }
  removeItem = (prod) => {
    console.log(prod);
    var order_items = this.props.root.state.detail.order_items;
    order_items.some( (oi, i) => {
        if(prod == oi.product_id){
          order_items.splice(i,1);
          return true;
        }
        return false;
    });
    this.props.root.setState({order_items : order_items});
  }
  contextHide = () => {
    this.setState({context: false});
  }
  contextShow = (cust, e) => {
    e.preventDefault();
    e.stopPropagation();
    var options = [
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Customer Email",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
      {title: "Select Customer",action:()=>{ this.setCustomer.bind(this,cust.id)() }},
    ]
    this.setState({context : {show: true, location: [e.clientX,e.clientY], options: options}});
  }
  editAddress = (tgt) => {
    this.setState({editAddress: tgt});
  }
  closeModal = () => {
    this.orderUncheck();
    this.setState({editAddress:undefined,mergeConfirm:false,uploader: false});
  }
  setAddress = (data, target) => {
    console.log(target, data);
    var detail = this.props.root.state.detail;
    var targets = ['delivery_address', 'invoice_address'];
    if(detail[target]){
      var add_id = detail[target].id;
      targets.forEach((tgt, i) => {
          if(add_id !== -1 && add_id == detail[tgt].id && tgt !== target){
              detail[tgt] = data;
          }
      })
    }
    detail[target] = data;
    this.props.root.setState({detail:detail});
    this.closeModal();
  }
  nextReference = () => {
    var detail = this.props.root.state.detail;
    console.log(detail.dispatch);
    return '!next';
  }
  setCustomer = (customer_id, e) => {
    if(e) {
      e.stopPropagation();
    }
    this.props.root.setState({customer_id: customer_id});
    FX.load(this.props.root, 'customerData2', (ex)=> {
        this.props.root.setState(ex);
    }, {method:'POST',data:{customer_id : customer_id}});
  }
  addAsNewDispatch = () => {
    var detail = this.props.root.state.detail;
    var dispatch = {
        id:-1,
        order_id: detail.id,
        customer_id:detail.customer_id,
        user_login_id: this.props.root.state.user.id,
        reference: this.nextReference(),
        dispatch_items:[],
        notes:detail.notes,
        post_service_id:detail.post_service_id,
        gift_message:detail.gift_message,
        delivery_instructions:detail.delivery_instructions,
        delivery_address: detail.delivery_address
    };
    var d = document.querySelectorAll('input.outstanding:checked');
    for(var i=0;i<d.length;i++){
      this.props.root.state.detail.warn.some(w => {
        if(w.id == d[i].dataset.warn_id){
          //list.push(d[i].dataset.warn_id);
          dispatch.dispatch_items.push({id:-1, product_id:  w.outstanding.product_id, quantity:  w.outstanding.outstanding});

          return true;
        }
        return false;
      })
    }
    console.log(dispatch);
    FX.load(this.props.root,'dispatch/create' , (res, i) => {
      console.log(res);
    }, {method:'POST',data:{dispatch : dispatch}});
  }
  handle (tgt, e){
    var detail = this.props.root.state.detail;
    if(detail){
      detail[tgt] = e.target.value;
      this.props.root.setState({detail:detail})
   }
   else{
      var setState = {};
      setState[tgt] = e.target.value;
      this.setState(setState);
   }
  }
  showCustomer = (cust) => {
    //this.props.root.setState({detail:cust})
    FX.navigate.bind(this.props.root,'customers', cust , '/clients/' + cust.id)();
  }
  render() {
    if(this.props.root.state.detail && typeof this.props.root.state.detail !== 'number' ){
      var detail = this.props.root.state.detail;
      console.log(this.props.root.state.detail);
      var sideButtons;

      var sideButtons = (
            <div id="sideButtons">
              <button onClick={this.showList}>Back</button>
              <button onClick={this.save}>Save</button>
            </div>
        )
      var customer = this.props.root.state.detail;
      var ps_set = [];
      var post_services = this.props.root.state.utilities.post_services.map(ps => {
        if(ps.client_selectable == 1 && !ps_set.includes(parseInt(ps.id,10))){
            ps_set.push(parseInt(ps.id,10));
            return (<option value={parseInt(ps.id,10)} >{ps.name}</option>)
        }
      });
      var className = "selectCustomer";
      var buttonText = "Select Customer";
      if(detail.id == this.props.root.state.customer_id){
        className += " Current";
        buttonText = "Customer Selected";
      }
      return (
        <div className="Customer">
                <div className="idents">
                    <div>
                      <label>Name:</label>
                      <input onChange={this.handle.bind(this, 'name')} value={this.props.root.state.detail.name}/>
                    </div>
                    <div>
                      <label>Full Name:</label>
                      <input onChange={this.handle.bind(this, 'fullname')} value={this.props.root.state.detail.fullname}/>
                    </div>
                    <div>
                      <label>Invoice Name:</label>
                      <input onChange={this.handle.bind(this, 'invoice_name')} value={this.props.root.state.detail.invoice_name}/>
                    </div>
                    <div>
                      <label>VAT Number:</label>
                      <input onChange={this.handle.bind(this, 'vat_number')} value={this.props.root.state.detail.vat_number}/>
                    </div>
                    <div>
                      <label>Company Number:</label>
                      <input onChange={this.handle.bind(this, 'company_number')} value={this.props.root.state.detail.company_number}/>
                    </div>
                    <div>
                      <label>EORI Number:</label>
                      <input onChange={this.handle.bind(this, 'eori')} value={this.props.root.state.detail.eori}/>
                    </div>
                </div>
                <div className="contact">
                    <div>
                      <label>Phone:</label>
                      <input onChange={this.handle.bind(this, 'phone')} value={this.props.root.state.detail.phone}/>
                    </div>
                    <div>
                      <label>Email:</label>
                      <input onChange={this.handle.bind(this, 'email')} value={this.props.root.state.detail.email}/>
                    </div>
                    <div>
                      <label>URL:</label>
                      <input onChange={this.handle.bind(this, 'url')} value={this.props.root.state.detail.url}/>
                    </div>
                </div>
                <div className="defaults">
                    <div>
                      <label>Reference Format:</label>
                      <input onChange={this.handle.bind(this, 'dispatch_reference_format')} value={this.props.root.state.detail.dispatch_reference_format}/>
                    </div>
                    <div>
                      <label>Default Shipping:</label>
                      <select value={parseInt(this.props.root.state.detail.default_shipping,10)} onChange={this.handle.bind(this, 'default_shipping')}>
                        {post_services}
                      </select>
                    </div>
                    <div>
                      <label>Invoice Due:</label>
                      <input onChange={this.handle.bind(this, 'invoice_due')} value={this.props.root.state.detail.invoice_due}/> days
                    </div>
                </div>
                <div className="defaults">
                    <div>
                      <label>Manage Inventory:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'manage_inventory')} checked={parseInt(this.props.root.state.detail.manage_inventory,10)} />
                    </div>
                    <div>
                      <label>Reorder Email:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'reorderMail')} checked={parseInt(this.props.root.state.detail.reorderMail,10)} />
                    </div>
                    <div>
                      <label>Email Template Format:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'auto_email_template_id')} checked={parseInt(this.props.root.state.detail.auto_email_template_id,10)} />
                    </div>
                    <div>
                      <label>Autohold:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'autohold')} checked={parseInt(this.props.root.state.detail.autohold,10)} />
                    </div>
                </div>
                <div className="options">
                    <div>
                      <label>Enable Expiry Dates:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'enable_expiries')} checked={parseInt(this.props.root.state.detail.enable_expiries,10)} />
                    </div>
                    <div>
                      <label>Enable Batch Numbers:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'enable_batch_numbers')} checked={parseInt(this.props.root.state.detail.enable_batch_numbers,10)} />
                    </div>
                    <div>
                      <label>Enable Composites:</label>
                      <input type="checkbox"  onClick={this.handleClick.bind(this, 'enable_composites')} checked={parseInt(this.props.root.state.detail.enable_composites,10)} />
                    </div>
                    <div>
                      <label>Delay Lead Time:</label>
                      <input onChange={this.handle.bind(this, 'delay_lead_time')} value={this.props.root.state.detail.delay_lead_time}/> days
                    </div>
                </div>

                <div id="SideBar">
                  <Scrollbars style={{ width: '100%' }}>
                      <div style={{padding:10}}>
                          <div>
                            <button className={className} onClick={this.setCustomer.bind(this,detail.id)}> {buttonText} </button>
                              <div>
                                <label>Warehouse Site:</label>
                                <select onChange={this.handle.bind(this, 'warehouse_site')} style={{width: '100%'}} value={parseInt(this.props.root.state.detail.warehouse_site,10)}>
                                    <option value={0}>Colton WH1&2</option>
                                    <option value={1}>Scottow</option>
                                    <option value={2}>Colton Warehouse 3</option>
                                </select>
                              </div>
                              <div>
                                <label>DHL Account:</label>
                                <input onChange={this.handle.bind(this, 'dhl_account')} value={this.props.root.state.detail.dhl_account}/>
                              </div>
                            <label>Active:</label>
                            <input type="checkbox"  onClick={this.handleClick.bind(this, 'status')} checked={parseInt(this.props.root.state.detail.status,10)} />
                          </div>
                      </div>
                  </Scrollbars>
                  {sideButtons}
                </div>
        </div>
      );
    }
    else {
      var customers_active;
      console.log(this.props.root.state.customers);
      if(Array.isArray(this.props.root.state.customers)){
        customers_active = this.props.root.state.customers.map(cust => {
          var pip;
          var className = "CustomerBtn";
          if(cust.id == this.props.root.state.customer_id){
            className += " Current";
            pip = (<div className="pip"></div>);
          }
          var ellipse;
          if(false){
            ellipse = (<div><span style={{padding:'0 10px'}} onClick={this.contextShow.bind(this,cust)}><i className="fa fa-ellipsis-v" /></span></div>);
          }
          if(cust.name && parseInt(cust.status) && (!this.state.filter || cust.name.toLowerCase().includes(this.state.filter) )){
            return (<div className={className} onClick={this.showCustomer.bind(this,cust)}>
              <div className="selectCircle"  onClick={this.setCustomer.bind(this,cust.id)} >{pip}</div>
              {cust.name}
              {ellipse}
            </div>)
          }
        });
      }
      var customers_inactive;
      console.log(this.props.root.state.customers);
      if(Array.isArray(this.props.root.state.customers)){
        customers_inactive = this.props.root.state.customers.map(cust => {
          var pip;
          var className = "CustomerBtn";
          if(cust.id == this.props.root.state.customer_id){
            className += " Current";
            pip = (<div className="pip"></div>);
          }
          var ellipse;
          if(false){
            ellipse = (<div><span style={{padding:'0 10px'}} onClick={this.contextShow.bind(this,cust)}><i className="fa fa-ellipsis-v" /></span></div>);
          }
          if(cust.name && !parseInt(cust.status) && (!this.state.filter || cust.name.toLowerCase().includes(this.state.filter) )){
            return (<div className={className} onClick={this.showCustomer.bind(this,cust)}>
              <div className="selectCircle" onClick={this.setCustomer.bind(this,cust.id)} >{pip}</div>
              {cust.name}
              {ellipse}
            </div>)
          }
        });
      }
      return (
        <div className="Customers">
            <div><button style={{padding:10}} onClick={this.addCustomer}><i className="fa fa-plus" aria-hidden="true" /> Add Customer</button></div>
            <div class="FilterBar">
                <input id="item_search"  onChange={this.handle.bind(this,'filter')} placeholder="Filter" value={this.state.filter} />
                <button id="filter_btn"><i className="material-icons">close</i></button>
            </div>
            <div className="Actives">
                <h4>Active</h4>
                <div className="customers_active">
                  {customers_active}
                </div>
            </div>
            <div className="separator" />
                <div className="Inactives">
                <h4>Inactive</h4>
                <div className="customers_inactive">
                  {customers_inactive}
                </div>
                <ContextMenu root={this.props.root} options={this.state.context.options}  location={this.state.context.location} parent={this} show={this.state.context.show} />
            </div>
        </div>
      );
    }
  }
}

export default Customer;



// WEBPACK FOOTER //
// ./src/Customer.js